import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from '@core/services/environment.service';
import { NavigationComponent } from '@features/navigation/components/navigation/navigation.component';
import { TripsItineraryDetailComponent } from '@features/trips/components/trips-itinerary-detail/trips-itinerary-detail.component';

@Component({
    selector: 'app-trip-variation-detail-page',
    templateUrl: './trip-variation-detail-page.component.html',
    imports: [NavigationComponent, TripsItineraryDetailComponent],
})
export class TripVariationDetailPageComponent implements OnInit {
    constructor(
        private router: Router,
        private environmentService: EnvironmentService,
        @Inject(DOCUMENT) private document: Document
    ) {}

    ngOnInit(): void {}
}
